var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewMoreIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9829 1C8.15564 1 4.22969 3.21513 1.13901 7.64539C1.05079 7.77324 1.00245 7.92436 1.00009 8.07968C0.997731 8.23499 1.04146 8.38752 1.12576 8.51799C3.50048 12.2352 7.37389 15.1423 11.9829 15.1423C16.5418 15.1423 20.4948 12.2264 22.8739 8.5008C22.9562 8.37288 23 8.22398 23 8.07187C23 7.91975 22.9562 7.77085 22.8739 7.64293C20.4894 3.96005 16.5074 1 11.9829 1Z",
    stroke: "#FF5F00",
    strokeWidth: 1.57136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 11.9994C14.1693 11.9994 15.9281 10.2406 15.9281 8.07098C15.9281 5.90139 14.1693 4.14258 11.9997 4.14258C9.8301 4.14258 8.07129 5.90139 8.07129 8.07098C8.07129 10.2406 9.8301 11.9994 11.9997 11.9994Z",
    stroke: "#FF5F00",
    strokeWidth: 1.57136,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMoreIcon);
export default __webpack_public_path__ + "static/media/View_More_icon.c51e6978228156ba36bbeccbdb145e85.svg";
export { ForwardRef as ReactComponent };